import { Injectable, signal } from '@angular/core';
import { OptionTypeResponse } from '../models/response-open-search';

@Injectable({ providedIn: 'root' })
export class OpenSearchDrawerService {
  isOpen = signal(false);
  rightWidth = signal(360);
  isVisibleSourcesDetails = signal(true);

  options = signal<OptionTypeResponse[]>([]);

  open(options: OptionTypeResponse[], width?: number) {
    this.options.set(options);
    if (width) this.rightWidth.set(width);
    this.isOpen.set(true);
    document.body.classList.add('no-scroll');
  }

  close() {
    this.isOpen.set(false);
    document.body.classList.remove('no-scroll');
  }

  toggleDetails() {
    this.isVisibleSourcesDetails.set(!this.isVisibleSourcesDetails());
  }

  startResize(startX: number) {
    const startWidth = this.rightWidth();
    const min = 320,
      max = 680;
    const move = (clientX: number) => {
      const delta = startX - clientX;
      const w = Math.max(min, Math.min(startWidth + delta, max));
      this.rightWidth.set(w);
    };
    return { move };
  }
}
